// OTP 發送驗證碼
export const POST_OTP_SEND_CODE_CALL = 'POST_OTP_SEND_CODE_CALL';
export const POST_OTP_SEND_CODE_DONE = 'POST_OTP_SEND_CODE_DONE';
export const POST_OTP_SEND_CODE_FAIL = 'POST_OTP_SEND_CODE_FAIL';

// OTP 驗證碼驗證
export const POST_OTP_VERIFY_CALL = 'POST_OTP_VERIFY_CALL';
export const POST_OTP_VERIFY_DONE = 'POST_OTP_VERIFY_DONE';
export const POST_OTP_VERIFY_FAIL = 'POST_OTP_VERIFY_FAIL';

// 重置 OTP 狀態
export const RESET_OTP_STATE = 'RESET_OTP_STATE';
